function getMockCampaign(){
  return {
    campaign: {
      image: 'https://s31.postimg.org/s036o6sd7/Suicide_Squad_logo_English_2.png',
    }
  };
}
function addSelectedImage(reaction){
  const selectedImage = reaction.image.replace('.svg', '_chosen.svg');
  const ret = { ...reaction, selectedImage: selected_image, };
  return ret;
}
export function getMockReactions({ doesIncludeCampaign = false, }){
  //todo: OREN - for a start, please add this JSON to the pdo
  // we can add more images later on
  const campaign = doesIncludeCampaign ? getMockCampaign() : {};
  const menuIcon = { 
    default_icon: 'http://dev.90min.com/assets/reactions_web/90min_default_icon.svg'
  };
  const reactions =  {
    reactions: [{
      id: "543b93b91669f8e5b0000002",
      text: "Love It",
      image: 'http://dev.90min.com/assets/reactions_web/90min_love_it_icon.svg',
    },
    {
      id: "543b93b91669f8e5b0000003",
      text: "Must Read",
      image: 'http://dev.90min.com/assets/reactions_web/90min_must_read_icon.svg',
    },
    {
      id: "543b93b91669f8e5b0000004",
      text: "LOL",
      image: 'http://dev.90min.com/assets/reactions_web/90min_lol_icon.svg',
    },
    {
      id: "543b93b91669f8e5b0000005",
      text: "No Way!",
      image: 'http://dev.90min.com/assets/reactions_web/90min_no_way_icon.svg',
    },
    {
      id: "543b93b91669f8e5b0000006",
      text: "Shocked",
      selectedImage: 'http://dev.90min.com/assets/reactions_web/90min_shocked_icon.svg_chosen',
      image: 'http://dev.90min.com/assets/reactions_web/90min_shocked_icon.svg',
    }
    ]
    .map(addSelectedImage)

  };
  return { ...reactions, ...campaign, ...menuIcon, }
}
export function getClientVotes(){
  return { 2558602: '543b93b91669f8e5b0000006', };
}
export function getPostVotes(){
  return {
    '543b93b91669f8e5b0000006': 4,
    '543b93b91669f8e5b0000005': 3,
    '543b93b91669f8e5b0000004': 2,
  };
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/reactions/mock/socialBarDataMock.js